import React, { useState, useEffect, createContext, useRef } from "react";
import { Spin, notification } from "antd";
import dayjs from 'dayjs';
const PublicContext = createContext();

function PublicContextProvider(props) {
    const [cart, setCart] = useState([]);
    const [cartNum, setCartNum] = useState(0);
    const [cartPrice, setCartPrice] = useState(0);
    const [loadingProduct, setLoadingProduct] = useState(false);
    const [loadingStore, setLoadingStore] = useState(false);
    const [loadingPromo, setLoadingPromo] = useState(false);
    const [loadingPromoProd, setLoadingPromoProd] = useState(false);
    const [loadingCart, setLoadingCart] = useState(false);
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [storeProducts, setStoreProducts] = useState([]);
    const [productCategories, setProductCategories] = useState([]);
    const [stores, setStores] = useState([]);
    const [promotions, setPromotions] = useState([]);
    const [uniquePromotions, setUniquePromotions] = useState([]);
    const [upsell, setUpsell] = useState([]);
    const [storeHours, setStoreHours] = useState([]);
    const [promotionProducts, setPromotionProducts] = useState([]);
    const [sideCartVisible, setSideCartVisible] = useState(false);
    const [isAbove991px, setIsAbove991px] = useState(window.innerWidth > 991);
    const [isSuccess, setIsSuccess] = useState(false);
    const [spinning, setSpinning] = useState(false);
    const [deliveryOrPickUp, setDeliveryOrPickUp] = useState(sessionStorage.getItem("deliveryOrPickUp") ?? "pickup");
    const [orderScheduleDate, setOrderScheduleDate] = useState(dayjs().format("MMM-DD"));
    const [orderScheduleTime, setOrderScheduleTime] = useState("");
    const [deliverable, setDeliverable] = useState(false);
    const isDeliverable = useRef(false);
    const [menuUrl, setMenuUrl] = useState(sessionStorage.getItem("menuUrl") ?? "");
    const [api, contextHolder] = notification.useNotification();
    const addressGeocode = useRef({ lat: 44, lng: -80 });
    const selectedStore = useRef({});
    const isMounted = useRef(false);

    const openNotification = (type, message, duration) => {
        api[type]({
            message: message,
            placement: "bottom",
            duration: duration ?? 2,
            className: type + 'Notification',
        });
    };

    const showLoader = () => {
        setSpinning(true);
        setTimeout(() => {
            setSpinning(false);
        }, 3000);
    };

    const handleSuccess = () => {
        setIsSuccess(true);
        setTimeout(() => {
            setIsSuccess(false);
        }, 5000);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsAbove991px(window.innerWidth > 991);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    //useEffect(() => {
    //    console.log("menuUrl Changed: " + menuUrl);
    //}, [menuUrl]);

    useEffect(() => {
        //if (!isMounted.current) {
        //    isMounted.current = true;
        //    console.log("deliveryOrPickUp useEffect mounting");
        //    return;
        //}
        //console.log("deliveryOrPickUp public context useEffect");
        //console.log("deliverable useEffect: " + deliverable);
        //console.log("isDeliverable: " + isDeliverable.current);
        sessionStorage.setItem("deliveryOrPickUp", deliveryOrPickUp);

        if (cart.length > 0) {
            changeOrderType();
        }

        setOrderScheduleTime("");
        sessionStorage.removeItem("scheduleTime");
    }, [deliveryOrPickUp]);

    useEffect(() => {
        //if (!isMounted.current) {
        //    isMounted.current = true;
        //    console.log("deliveryOrPickUp useEffect mounting");
        //    return;
        //}
        //console.log("deliverable useEffect: " + deliverable);
        //console.log("isDeliverable before: " + isDeliverable.current);
        isDeliverable.current = deliverable;
        //console.log("isDeliverable after: " + isDeliverable.current);
    }, [deliverable]);

    async function changeOrderType() {
        //console.log("change order type");
        setSpinning(true);
        if (window.gtag) {
            window.gtag('event', 'ChangeOrderType', {
                event_category: 'Button',
                event_label: 'ChangeOrderType',
            });
        }
        //var storeCode = JSON.parse(sessionStorage.getItem("selectedStore")).storeCode;
        //await fetch("api/Carts/change-order-type?OrderType=" + sessionStorage.getItem("deliveryOrPickUp") + "&StoreCode=" + storeCode, {
        await fetch("api/Carts/change-order-type?OrderType=" + sessionStorage.getItem("deliveryOrPickUp"), {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            }
        })
            .then(async (response) => {
                setSpinning(false);
                console.log(response);
                const data = await response.json();
                console.log(data);

                //console.log(data.length);
                //console.log(data.size);
                if (data.length > 0) {
                    const totalQuantity = data.reduce(
                        (acc, obj) => acc + obj.quantity,
                        0
                    );

                    setCartNum(totalQuantity);
                    setCartPrice(data[0].orderSubtotal);

                    setCart(data);
                    localStorage.setItem("cart", JSON.stringify(data));
                }
                else {
                    setCartNum(0);
                    setCartPrice(0);

                    setCart([]);
                    localStorage.setItem("cart", JSON.stringify([]));
                }
                //console.log("deliveryOrPickUp: " + deliveryOrPickUp );
                //console.log("deliverable: " + deliverable);
                //console.log("isDeliverable: " + isDeliverable);
                //console.log("isDeliverable: " + isDeliverable.current);
                //if (deliveryOrPickUp === "delivery" && deliverable) {
                if (sessionStorage.getItem("deliveryOrPickUp") === "delivery" && isDeliverable.current) {
                    setSpinning(true);
                    //console.log("calculate delivery after changing order type")
                    await CalculateDelivery();
                }
            })
            .catch(async (error) => {
                setSpinning(false);
                openNotification("error", "Something went wrong. Please try again.");

                //setCartNum(0);
                //setCartPrice(0);

                //setCart([]);
                //localStorage.setItem("cart", JSON.stringify([]));

                //if (sessionStorage.getItem("deliveryOrPickUp") === "delivery" && isDeliverable.current) {
                //    setSpinning(true);
                //    //console.log("calculate delivery after changing order type")
                //    await CalculateDelivery();
                //}
                //console.error(error);
                // setSubmitDistabled(false);
            });
    }

    async function CalculateDelivery() {
        await fetch(("api/Carts/calculate-delivery?lat=" + addressGeocode.current.lat + "&lng=" + addressGeocode.current.lng + "&StoreCode=" + selectedStore.current.storeCode + "&StoreId=" + selectedStore.current.storeId), {
            //await fetch("api/Orders/InitPayment", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            //body: JSON.stringify(order),
        })
            .then(async (response) => {
                setSpinning(false);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();

            })
            .then(data => {
                setCart(data);
                localStorage.setItem("cart", JSON.stringify(data));
                setDeliverable(true);
            })
            .catch((error) => {
                setSpinning(false);
                //console.error(error);
            });
    }
    async function getToken() {
        //console.log("getToken");
        // if (localStorage.getItem("products")) {
        //   setProducts(JSON.parse(localStorage.getItem("products")));
        //   console.log(JSON.parse(localStorage.getItem("products")));
        // } else {
        var accessToken = localStorage.getItem("accessToken") ?? null;
        if (accessToken != null) {
            //const response = await fetch("api/Token/renew-token");
            await fetch("api/Token/renew-token", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'Authorization': `Bearer `+ accessToken,
                },
                body: JSON.stringify({ CurrentToken: accessToken })
            })
                .then(async (response) => {
                    //console.log(response);
                    const data = await response.json();
                    //console.log(data);
                })
                .catch((error) => {
                    //console.error(error);
                    // setSubmitDistabled(false);
                });
        }
        else {
            await fetch("api/Token/generate-customer-token", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    //console.log(response);
                    const data = await response.json();
                    //console.log(data.accessToken);
                    accessToken = data.accessToken;
                    localStorage.setItem("accessToken", accessToken);
                    populateProductData(accessToken);
                    populateStoreData();
                    populateCartData();
                    populatePromoData();
                    setLoading(false);
                })
                .catch((error) => {
                    //console.error(error);
                    // setSubmitDistabled(false);
                });
        }
    }

    async function populateData() {
        const response = await fetch("api/Products/InitiateData", {
            method: 'Get',
            headers: {
                'Content-Type': 'application/json'
            },
        });
        //console.log("populateData");
        //console.log(response);
        const data = await response.json();
        //console.log(data);

        setProducts(data.products);
        setLoadingProduct(true);
        localStorage.setItem("products", JSON.stringify(data.products));

        setStores(data.stores);
        setLoadingStore(true);
        localStorage.setItem("stores", JSON.stringify(data.stores));

        //const arrayOfIDs = data.promoData.map((obj) => obj.id);
        //console.log(arrayOfIDs);
        //const uniquePromoData = data.promoData.filter(
        //    (promo, index, self) => index === self.findIndex((t) => t.promotionPicture === promo.promotionPicture)
        //);
        const uniquePromoData = data.promoData;
        setPromotions(data.promoData);
        setUniquePromotions(uniquePromoData);
        localStorage.setItem("Promotions", JSON.stringify(uniquePromoData));
        setLoadingPromo(true);

        setPromotionProducts(data.promoProducts);
        setLoadingPromoProd(true);
        localStorage.setItem("PromotionProducts", JSON.stringify(data.promoProducts));

        //setUpsell(data.upsell.productCodesList);
        setUpsell(data.upsell);

        setStoreHours(data.storeHours);

        setProductCategories(data.productCategories);

        setStoreProducts(data.storeProducts);

        localStorage.setItem("StorePromotions", JSON.stringify(data.storePromotions));

        //const imageresponse = await fetch("api/Products/menu-images", {
        //    method: 'Get',
        //    headers: {
        //        'Content-Type': 'application/json'
        //    },
        //});
        //const imagedata = await imageresponse.json();
        //console.log(imagedata);

        populateCartData();
    }

    async function populateProductData() {

        // if (localStorage.getItem("products")) {
        //   setProducts(JSON.parse(localStorage.getItem("products")));
        //   console.log(JSON.parse(localStorage.getItem("products")));
        // } else {
        const response = await fetch("api/Products", {
            method: 'Get',
            headers: {
                'Content-Type': 'application/json'
            },
        });
        //console.log("populateProductData");
        //console.log(response);
        const data = await response.json();
        setProducts(data);
        setLoadingProduct(true);
        localStorage.setItem("products", JSON.stringify(data));
        //console.log(data);
        // }
    }

    async function populateStoreData() {
        //console.log("populateStoreData");
        // if (localStorage.getItem("stores")) {
        //   setStores(JSON.parse(localStorage.getItem("stores")));
        //   console.log(JSON.parse(localStorage.getItem("stores")));
        // } else {
        const response = await fetch("api/Stores");
        const data = await response.json();
        setStores(data);
        setLoadingStore(true);
        localStorage.setItem("stores", JSON.stringify(data));
        //console.log(data);
        // }
    }

    async function populatePromoData() {
        //console.log("populatePromoData");
        const response = await fetch("api/Promotions/GetActivePromo");
        const data = await response.json();
        //console.log(data);
        if (data) {
            const arrayOfIDs = data.map((obj) => obj.id);
            //console.log(arrayOfIDs);
            const uniquePromoData = data.filter(
                (promo, index, self) => index === self.findIndex((t) => t.promotionPicture === promo.promotionPicture)
            );
            populatePromoProductData(arrayOfIDs);
            setPromotions(data);
            setUniquePromotions(uniquePromoData);
            localStorage.setItem("Promotions", JSON.stringify(uniquePromoData));
        }
        setLoadingPromo(true);
    }

    async function populatePromoProductData(PromoIds) {
        //console.log("populatePromoProductData");
        await fetch("api/PromotionProducts/GetActivePromotionProductsByIdList", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            body: JSON.stringify(PromoIds),
        }).then(async (response) => {
            // console.log(response);
            const data = await response.json();
            //console.log(data);
            setPromotionProducts(data);
            localStorage.setItem("PromotionProducts", JSON.stringify(data));
            setLoadingPromoProd(true);
        });
    }

    async function populateCartData() {
        await fetch("api/Carts/get-cart", {
            method: 'Get',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(async (response) => {
                //console.log("populate cart");
                console.log(response);
                const data = await response.json();
                console.log(data);

                setCart(data);
                localStorage.setItem("cart", JSON.stringify(data));

                var totalNumItem = 0;
                data.forEach((cartItem) => {
                    totalNumItem += cartItem.quantity;
                });

                if (totalNumItem > 0) {
                    var totalprice = data[0].orderSubtotal;

                    //console.log("cartNum: " + totalNumItem);
                    setCartNum(totalNumItem);
                    setCartPrice(totalprice);
                }
                else {
                    setCart([]);
                    localStorage.setItem("cart", JSON.stringify([]));

                    setCartNum(0);
                    setCartPrice(0);
                }

                //console.log("populate cart data change order type");
                //console.log("isDeliverable: " + isDeliverable.current);
                changeOrderType();

                //var tempCart = localStorage.getItem("cart");
                //console.log(tempCart);
                //if (tempCart != null) {
                //    var parseCart = JSON.parse(tempCart);
                //    if (parseCart.length > 0) {
                //        //console.log("tempCart.length: " + tempCart.length);
                //        setCart(parseCart);
                //        var totalNumItem = 0;
                //        var totalprice = parseCart[0].orderSubtotal;
                //        parseCart.forEach((cartItem) => {
                //            totalNumItem += cartItem.quantity;
                //        });
                //        //console.log("cartNum: " + totalNumItem);
                //        setCartNum(totalNumItem);
                //        setCartPrice(totalprice);
                //    }
                //}
                setLoadingCart(true);
            })
            .catch(e => {
                console.log(e);
                setCart([]);
                localStorage.setItem("cart", JSON.stringify([]));

                setCartNum(0);
                setCartPrice(0);
                changeOrderType();
            });
    }

    async function populateUpsell() {
        //console.log("populateUpsell");
        await fetch("api/UpsellManuals", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            }
        })
            .then(async (response) => {
                const responseData = await response.json();
                setUpsell(responseData.productCodesList)
                //console.log(responseData);
            })
            .catch((error) => {
                //console.error(error);
            });
    }

    const clearAllStorage = () => {
        // Clear session storage
        sessionStorage.clear();

        // Clear local storage
        //localStorage.clear();

        // Clear cache
        if (caches) {
            caches.keys().then((cacheNames) => {
                cacheNames.forEach((cacheName) => {
                    caches.delete(cacheName);
                });
            });
        }

        // Reload the page to reflect the changes
        //window.location.reload(true);
    };

    useEffect(() => {
        //console.log("Public Context useEffect");
        sessionStorage.removeItem("paymentuid");
        sessionStorage.setItem("scheduleTime", "");
        sessionStorage.removeItem("selectedAddress");

        //console.log("before populateData");
        populateData();
        const interval = setInterval(() => {
            //console.log("populateData");
            populateData();
        }, 30 * 60 * 1000); //  + Math.random() * 1000 for 2000ms to 3000ms

        return () => {
            clearInterval(interval); // Cleanup on component unmount
        }

        //getToken();
        //clearAllStorage();
        //populateProductData();
        //populateStoreData();
        //populateCartData();
        //populatePromoData();
        //populateUpsell();
        //populateStoreHours();
        //popluateProductCategories();
        //setLoading(false);
    }, []);

    useEffect(() => {
        //console.log("checking if all data is loaded");
        if (loadingProduct && loadingStore && loadingPromo && loadingPromoProd && loadingCart) {
            //console.log("All data loaded");
            setLoading(false);
        }
    }, [loadingProduct, loadingStore, loadingPromo, loadingPromoProd, loadingCart]);

    //useEffect(() => {
    //    console.log("checking if all data is loaded");
    //    if (products && stores && promotions && promotionProducts && cart) {
    //        if (products.size > 0 && stores.size > 0 && promotions.size > 0 && promotionProducts.size > 0 && cart) {
    //            console.log("All data loaded");
    //            setLoading(false);
    //        }
    //    }
    //}, [products, stores, promotions, promotionProducts, cart]);

    useEffect(() => {
        localStorage.setItem("mandarinCart", JSON.stringify(cartNum));
    }, [cartNum]);

    return (
        <>
            {contextHolder}
            <Spin style={{ zIndex: "9999" }} spinning={spinning} fullscreen />
            {loading ? <></> : <PublicContext.Provider
                value={{
                    products,
                    populateProductData,
                    cartNum,
                    setCartNum,
                    promotions,
                    uniquePromotions,
                    promotionProducts,
                    productCategories,
                    storeProducts,
                    setStoreProducts,
                    upsell,
                    storeHours,
                    loading,
                    stores,
                    setStores,
                    cartPrice,
                    setCartPrice,
                    cart,
                    setCart,
                    sideCartVisible,
                    setSideCartVisible,
                    isAbove991px,
                    handleSuccess,
                    isSuccess,
                    setIsSuccess,
                    spinning,
                    setSpinning,
                    showLoader,
                    openNotification,
                    orderScheduleTime,
                    setOrderScheduleTime,
                    orderScheduleDate,
                    setOrderScheduleDate,
                    deliveryOrPickUp,
                    setDeliveryOrPickUp,
                    menuUrl,
                    setMenuUrl,
                    changeOrderType,
                    CalculateDelivery,
                    addressGeocode,
                    deliverable,
                    setDeliverable,
                    selectedStore
                }}
            >
                {props.children}
            </PublicContext.Provider>
            }
        </>
    );
}

export { PublicContextProvider, PublicContext };
